import React from 'react';
import classNames from 'classnames';
import TextField from '@mui/material/TextField';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const AddTechnicianName = (props) => {
  const { onBack, onNext, selectedTechnicianName, setSelectedTechnicianName } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Who is the technician performing this technical service?</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>Write down the name of the technician who's putting in that work for you</p>
          <TextField
            required
            id="technician-name"
            label="Technician Name"
            onChange={(event) => {
                setSelectedTechnicianName(event.target.value);
            }}
            sx={{ width: '300px' }}
            value={selectedTechnicianName ?? ''}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            [styles.disabled]: !selectedTechnicianName,
          })}
          disabled={!selectedTechnicianName}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

export default AddTechnicianName;
